import { useAppSelector } from '@/store/hooks'
import type { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'

// @todo minor tech debt replace selector to this hook
export const useActivitiesWithAggregates = (): FrontActivityWithAggregate | null =>
  useAppSelector((store) => store.aggregate.activitiesWithAggregates)
